import {
  LOCATION_FILTER_KEYS,
  REGION_FILTER_KEYS,
} from '../../Constants/Filters/LocationFilter.constants';
import { FILTERS_PROPS as LOC_FILTER_PROPS } from '../../Constants/Filters/LocationFilter.constants';
import { filterKeys, FILTERS_NOT_FOR_DISPLAY } from '../../Constants/SearchFilters';
import { Locale } from '../../Entities/Locale/Locale.entity';
import { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';
import { FilterValueDisplayObj } from '../../Entities/Search/SearchFilters/FilterValueDisplayObj.entity';
import { MULTIPLE_FILTER_VALUES_CONFIG } from '../../Services/Search/Filters.constants';

export const mapFiltersForDisplay = (filters: Filter[], _locale: Locale) => {
  const outputFilters: FilterValueDisplayObj[] = [];

  const hasDealershipFilter = filters.some(filter => filter.id === 'dealership-id');
  const hasRegionFilter = filters.some(filter => filter.id === 'region');
  const hasAreaFilter = filters.some(filter => filter.id === 'area');

  filters
    .filter(filter => filterKeys.includes(filter.id))
    .forEach(filter => {
      if (FILTERS_NOT_FOR_DISPLAY.includes(filter.id)) return;
      if (hasDealershipFilter && (filter.id === 'dealer-id' || filter.id === 'postcode')) return;
      if (hasRegionFilter && filter.id === 'postcode') return;
      if (hasAreaFilter && filter.id === 'region') return;
      if (filter.id === 'vehicle-status' && filter.value === 'active') return;

      const filterNameParts = filter.id.split('__');
      const locationFilterObj = LOC_FILTER_PROPS.find(locFltr => locFltr.key === filter.id);
      const filterNamePure = locationFilterObj?.filterType ?? filterNameParts[0];
      const filterFn = filterNameParts[1];
      const isLocationFilter = LOCATION_FILTER_KEYS.includes(filter.id);
      const isRegionFilter = REGION_FILTER_KEYS.includes(filter.id);
      const multipleFilterValuesConfig = MULTIPLE_FILTER_VALUES_CONFIG;
      const specificFilterValueConfig =
        multipleFilterValuesConfig[filter.id as keyof typeof multipleFilterValuesConfig];

      if (filterFn || isLocationFilter || isRegionFilter) {
        const rangeProp: Record<string, string> = {
          gte: 'valueGte',
          lte: 'valueLte',
        };

        const existingRecord = outputFilters.find(fltr => fltr.id === filterNamePure);
        const valueProp = rangeProp[filterFn] || filter.id;
        if (existingRecord) {
          existingRecord[valueProp] = filter.value;
          existingRecord.originalFilters = [...existingRecord.originalFilters, filter];
        } else {
          outputFilters.push({
            id: filterNamePure,
            originalFilters: [
              { ...filter },
              ...(isLocationFilter ? [{ id: 'max-distance', value: undefined } as Filter] : []),
            ],
            [valueProp]: filter.value,
          });
        }
      } else if (
        Array.isArray(filter.value) &&
        specificFilterValueConfig?.filterValues &&
        specificFilterValueConfig?.filterValues.length > 0
      ) {
        const filterValues = specificFilterValueConfig.filterValues;

        // Check if filterValues is an array of arrays (for grouped filters)
        if (Array.isArray(filterValues[0])) {
          // Grouped logic for filters like 'doors' for DE
          const groupedMatchingFilters: FilterValueDisplayObj[] = [];

          // Process each group to find matches
          (filterValues as string[][]).forEach((group: string[]) => {
            const matchingValues = Array.isArray(filter.value)
              ? filter.value.filter(value => group.includes(value))
              : [];
            if (matchingValues.length > 0) {
              groupedMatchingFilters.push({
                id: filter.id,
                value: matchingValues.length === 1 ? matchingValues[0] : matchingValues, // Single match as string, multiple as array
                originalFilters: [filter],
              });
            }
          });

          // Handle any additional values not in groups
          const allGroupedValues = filterValues.flat();
          const additionalValues = filter.value.filter(value => !allGroupedValues.includes(value));

          if (groupedMatchingFilters.length > 0) {
            outputFilters.push(...groupedMatchingFilters);
          }

          additionalValues.forEach(value => {
            outputFilters.push({
              id: filter.id,
              value: value,
              originalFilters: [filter],
            });
          });
        } else {
          const matchingValues = filter.value.filter(value =>
            (filterValues as string[]).includes(value),
          );
          const additionalValues = filter.value.filter(
            value => !(filterValues as string[]).includes(value),
          );

          if (matchingValues.length > 0) {
            outputFilters.push({
              id: filter.id,
              value: matchingValues.length === 1 ? matchingValues[0] : matchingValues, // Single match as string, multiple as array
              originalFilters: [filter],
            });
          }

          additionalValues.forEach(value => {
            outputFilters.push({
              id: filter.id,
              value: value,
              originalFilters: [filter],
            });
          });
        }
      } else if (Array.isArray(filter.value)) {
        filter.value.forEach(value => {
          outputFilters.push({
            ...(filter as FilterValueDisplayObj),
            value,
            originalFilters: [filter],
          });
        });
      } else {
        outputFilters.push({
          ...(filter as FilterValueDisplayObj),
          originalFilters: [filter],
        });
      }
    });

  return outputFilters;
};
